import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Wrench } from 'lucide-react';
import { motion } from 'framer-motion';

import { Button } from '../../../components/ui/button.tsx';
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../../components/ui/card.tsx';

const Notifications = () => {
  const navigate = useNavigate();
  const { state } = useLocation();

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{
        duration: 0.5,
        ease: 'easeInOut',
      }}
    >
      <p className="text-xl mb-4">{state?.label || 'Notifications'}</p>
      <div className="flex h-full items-center justify-center bg-white p-6 ">
        <Card className="max-w-md w-full">
          <CardHeader className="flex flex-col items-center space-y-2">
            <Wrench className="h-12 w-12 text-purple-600" />
            <CardTitle>This Page Is Under Construction</CardTitle>
          </CardHeader>
          <CardContent className="text-center space-y-4">
            <p className="text-gray-600">
              We’re busy building something awesome here. Check back soon!
            </p>
            <Button
              variant="outline"
              onClick={() => navigate(-1)}
              className="w-full"
            >
              Go Back
            </Button>
          </CardContent>
        </Card>
      </div>
    </motion.div>
  );
};

export default Notifications;
